import React, { ReactNode } from 'react';

import Box from '@material-ui/core/Box';
interface TabPanelProps {
  index?: number;
  value?: number;
  dir?: string;
  children?: ReactNode;
}

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  dir,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};
